<mat-icon
  ><span class="material-icons-outlined">
    format_bold
  </span></mat-icon
>
